import React from 'react';

const BADGE_STYLES = {
    ORDER_STATUS: { background: '#E7F1FF', color: '#1D5DB8', label: 'Order Status' },
    LINE_ITEM_STATUS: { background: '#F1E9FB', color: '#6F3FA0', label: 'Line Item Status' },
    ORDER_COMMENT: { background: '#E6F6EA', color: '#1F8A3B', label: 'Comment' },
    ORDER_ACCESS: { background: '#FFF4E5', color: '#B86E00', label: 'Order Access' },
};

const DELETED_COMMENT_STYLE = { background: '#FDEAEA', color: '#C4302B', label: 'Comment' };

const ActionTypeBadge = ({ actionType, actionDetail }) => {
    const isDeletedComment = actionType === 'ORDER_COMMENT' && actionDetail === 'Comment deleted';
    const style = isDeletedComment
        ? DELETED_COMMENT_STYLE
        : (BADGE_STYLES[actionType] || { background: '#EEEEEE', color: '#555555', label: actionType || '—' });

    return (
        <span
            className="oh-action-badge"
            title={style.label}
            style={{
                background: style.background,
                color: style.color,
            }}
        >
            {style.label}
        </span>
    );
};

export default ActionTypeBadge;
